import { HalfModalBase } from '@/components/layout/modals/HalfModalBase';
import type { HalfModalType } from '@/components/layout/modals/types';
import { DynamicPortal } from '@/utils/dynamic-portal';

export const HalfModalPortal = (props: HalfModalType) => {
  const { portalId } = props;
  return (
    <DynamicPortal id={portalId || 'modalPortal'}>
      <HalfModalBase {...props} />
    </DynamicPortal>
  );
};
